export default {"src":"/_next/static/media/tiktok.bb8164c4.svg","height":25,"width":21,"blurWidth":0,"blurHeight":0};